import axios from "axios";
import { useState, useEffect } from "react";
import { getEvidenceType } from "../../../../common/EntitiesManagement";
import localize from "../../../../common/localize";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import {
  EvidenceTypeEnum,
  getClassForRotation,
} from "../../../../common/utils";

export default function ReportEvidenceItem({
  evidence,
  eventId,
  reviews,
  original,
  panelReport,
  columns,
  hideModificationDate,
}) {
  const { EVENTS_API, config } = useGlobalContext();
  const [imageBlob, setImageBlob] = useState();

  const existsReviewRelatedToEvidence = (evidenceId) => {
    if (!evidenceId || !reviews || reviews?.length === 0) {
      return false;
    }

    const found = reviews.find(
      (element) => element.Evidence?.Id === evidenceId,
    );
    return !!found;
  };

  const getReviewRelatedToEvidence = (evidenceInformation) => {
    const found = reviews.filter(
      (element) => element.Evidence?.Id === evidenceInformation?.Id,
    );
    if (found && found?.length > 0) {
      return found.map((item) => (
        <div
          key={item.Id}
          className={`flex flex-col ${panelReport ? "justify-center" : ""}`}
          style={
            panelReport
              ? {
                  alignItems: "center",
                  width: "100%",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                  marginTop: "5px",
                  borderTop: "1px solid",
                }
              : { marginTop: "5px" }
          }
        >
          <label
            className="report_little_text"
            style={{
              width: "100%",
              textAlign:
                panelReport &&
                (evidence.EvidenceType !== EvidenceTypeEnum.Audio ||
                  evidence.EvidenceType !== EvidenceTypeEnum.Video)
                  ? "center"
                  : "start",
            }}
          >
            <b>{item.Title}: </b>
            {item.Observation}
          </label>

          {!hideModificationDate && (
            <label
              className="report_small_text"
              style={{ width: "100%", textAlign: "center" }}
            >
              {`${localize.reported_by}: ${item.CreatedBy} (${new Date(
                item.CreationDate,
              ).toLocaleString(undefined, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })})`}
            </label>
          )}
        </div>
      ));
    }
  };

  const downloadEvidence = async (evidenceData) => {
    const image = await axios({
      ...config,
      method: "get",
      responseType: "blob", // Force to receive data in a Blob Format
      url: `${EVENTS_API}/${eventId}/evidence/${evidenceData.Id}/download`,
    });

    if (image?.data) {
      const blob = new Blob([image.data], {
        type: "application/octet-stream",
      });

      const urlBlob = URL.createObjectURL(blob);
      setImageBlob(urlBlob);
    }
  };

  useEffect(() => {
    if (evidence.EvidenceType === 1) {
      downloadEvidence(evidence);
    }
  }, []);

  const getEvidenceName = (evidenceInfo) => (
    <label
      className="report_little_text"
      style={{
        textAlign:
          evidenceInfo.EvidenceType === EvidenceTypeEnum.Image
            ? "center"
            : "start",
      }}
    >
      <b>{`${
        original ? evidenceInfo?.OriginalName : evidenceInfo?.Name
      } (${getEvidenceType(evidenceInfo.EvidenceType)})`}</b>
    </label>
  );

  const mustHideGps = () =>
    (!original && evidence.FromWeb) ||
    (evidence.GpsLatitude === 0 && evidence.GpsLongitude === 0);

  const getModifiedByData = () => (
    <label
      className="report_small_text"
      style={{
        textAlign:
          evidence.EvidenceType === EvidenceTypeEnum.Image ? "center" : "start",
      }}
    >
      {`${localize.modified_by}: ${evidence.ModifiedBy}, ${new Date(
        evidence?.ModificationDate,
      ).toLocaleString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })}`}
    </label>
  );

  const getGpsData = () => (
    <label
      className="report_little_text"
      style={{
        textAlign:
          evidence.EvidenceType === EvidenceTypeEnum.Image ? "center" : "start",
        marginLeft: panelReport ? "0px" : "12px",
      }}
    >{`${localize.gps_latitude}: ${evidence.GpsLatitude} - ${localize.gps_longitude}: ${evidence.GpsLongitude}`}</label>
  );

  const getEvidenceImage = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: panelReport ? "5px" : "0px",
        height: "100%",
      }}
    >
      <figure className="flex flex-col items-center justify-center w-full">
        <img
          src={imageBlob}
          alt={evidence?.Name}
          className={getClassForRotation(evidence?.AdditionalData)}
          style={{
            width: panelReport
              ? columns == 1
                ? "500px"
                : columns == 2
                ? "250px"
                : "200px"
              : "240px",
            height: panelReport
              ? columns == 1
                ? "650px"
                : columns == 2
                ? "300px"
                : "250px"
              : "280px",
            minWidth: panelReport
              ? columns == 1
                ? "500px"
                : columns == 2
                ? "250px"
                : "200px"
              : "250px",
            border: "1px solid",
            margin: panelReport ? "0px" : "5px",
            maxWidth: "none",
          }}
        />
        {panelReport && (
          <figcaption>
            <div
              className="flex flex-col"
              style={{
                justifyItems: "center",
                alignItems: "center",
                width: "100%",
                marginTop: "5px",
                padding: "5px",
              }}
            >
              {evidence.EvidenceType === EvidenceTypeEnum.Image &&
                getEvidenceName(evidence)}

              {!hideModificationDate && getModifiedByData()}

              {!mustHideGps() && getGpsData()}

              {existsReviewRelatedToEvidence(evidence?.Id) &&
                getReviewRelatedToEvidence(evidence)}
            </div>
          </figcaption>
        )}
      </figure>
    </div>
  );

  const getPanelReportItem = () => (
    <div
      className="flex flex-col items-center justify-center w-full"
      style={{ border: "0.5px solid", height: "100%", overflow: "hidden" }}
    >
      {getEvidenceImage()}
    </div>
  );

  const getFieldItem = () => (
    <div className="flex report_internal_field w-full print-row">
      {getEvidenceImage()}

      <div
        className="flex flex-col"
        style={{ padding: "5px", flexGrow: 1, justifyContent: "center" }}
      >
        {evidence.EvidenceType === EvidenceTypeEnum.Image &&
          getEvidenceName(evidence)}

        {!hideModificationDate && getModifiedByData()}

        {!mustHideGps() && getGpsData()}

        {existsReviewRelatedToEvidence(evidence?.Id) &&
          getReviewRelatedToEvidence(evidence)}
      </div>
    </div>
  );

  return (
    <div
      key={`evidence_${evidence?.Id}_0`}
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div key={`evidence_${evidence?.Id}_1`} className="page-break" />
      <div
        key={`evidence_${evidence?.Id}_2`}
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {evidence.EvidenceType === EvidenceTypeEnum.Image ? (
          <div
            key={`evidence_${evidence?.Id}_2`}
            className={panelReport ? "gridItem" : "flex"}
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            {panelReport ? getPanelReportItem() : getFieldItem()}
          </div>
        ) : (
          <div
            key={`evidence_${evidence?.Id}_3`}
            className="flex flex-col report_internal_field"
          >
            {getEvidenceName(evidence)}
            {!evidence.FromWeb
              ? getGpsData()
              : !hideModificationDate && getModifiedByData()}
            {existsReviewRelatedToEvidence(evidence?.Id) &&
              getReviewRelatedToEvidence(evidence)}
          </div>
        )}
      </div>
    </div>
  );
}
